import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    homeLoading(state) {
      state.loading = true;
      state.error = null;
    },
    homeError(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    setHomeList(state, action) {
      state.loading = false;
      state.data = action.payload;
    },
  },
});

export const { loading, error, setList } = loginSlice.actions;

export default loginSlice.reducer;
